import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { isAdmin } from '../lib/auth';
import './AdminDashboard.css';
import UserManagement from './admin/UserManagement';
import EventManagement from './admin/EventManagement';
import EventRegistrations from './admin/EventRegistrations';
import BannerManagement from './admin/BannerManagement';
import PhotoManagement from './admin/PhotoManagement';
import MediaManagement from './admin/MediaManagement';
import PartnerManagement from './admin/PartnerManagement';
import NewsManagement from './admin/NewsManagement';
import FAQManagement from './admin/FAQManagement';
import ScholarshipRecipientsManagement from './admin/ScholarshipRecipientsManagement';
import MembershipOptionsManagement from './admin/membershipoptionsmanagement';
import RoundWinnersManagement from './admin/RoundWinnersManagement';
import PastChampionsManagement from './admin/Pastchampionsmanagement';

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('users');

  // Check admin access
  React.useEffect(() => {
    if (!isAdmin()) {
      navigate('/dashboard');
    }
  }, [navigate]);

  const tabs = [
    { id: 'users', label: 'Users', icon: '👥' },
    { id: 'events', label: 'Events', icon: '📅' },
    { id: 'registrations', label: 'Registrations', icon: '📝' },
    { id: 'banner', label: 'Banner', icon: '📢' },
    { id: 'photos', label: 'Photos', icon: '📸' },
    { id: 'media', label: 'Media', icon: '🖼️' },
    { id: 'partners', label: 'Partners', icon: '🤝' },
    { id: 'news', label: 'News', icon: '📰' },
    { id: 'faq', label: 'FAQ', icon: '❓' },
    { id: 'scholarship', label: 'Scholarships', icon: '🎓' },
    { id: 'membership', label: 'Membership', icon: '⭐️' },
    { id: 'standings', label: 'Standings', icon: '🏆' },
    { id: 'past_champions', label: 'Past Champions', icon: '🥇' }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'users':
        return <UserManagement />;
      case 'events':
        return <EventManagement />;
      case 'registrations':
        return <EventRegistrations />;
      case 'banner':
        return <BannerManagement />;
      case 'photos':
        return <PhotoManagement />;
      case 'media':
        return <MediaManagement />;
      case 'partners':
        return <PartnerManagement />;
      case 'news':
        return <NewsManagement />;
      case 'faq':
        return <FAQManagement />; 
      case 'scholarship':
        return <ScholarshipRecipientsManagement />;  
      case 'membership':
        return <MembershipOptionsManagement />;  
      case 'standings':
        return <RoundWinnersManagement />;  
      case 'past_champions':
        return <PastChampionsManagement />;    
      default:
        return <UserManagement />;
    }
  };

  return (
    <div className="admin-dashboard">
      <div className="admin-header">
        <h1>Admin Dashboard</h1>
        <button onClick={() => navigate('/dashboard')} className="btn-secondary">
          Back to User Dashboard
        </button>
      </div>

      <div className="admin-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`admin-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            <span className="tab-icon">{tab.icon}</span>
            <span className="tab-label">{tab.label}</span>
          </button>
        ))}
      </div>

      <div className="admin-content">
        {renderTabContent()}
      </div>
    </div>
  );
};

export default AdminDashboard;
